import React from "react";

export function AddHighlightIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.08934 8.57745C8.41477 8.90289 8.41477 9.43053 8.08934 9.75596L3.33341 14.5119V15.8334H9.6549L11.9108 13.5775C12.2363 13.252 12.7639 13.252 13.0893 13.5775C13.4148 13.9029 13.4148 14.4305 13.0893 14.756L10.5893 17.256C10.4331 17.4122 10.2211 17.5 10.0001 17.5H2.50008C2.03984 17.5 1.66675 17.1269 1.66675 16.6667V14.1667C1.66675 13.9457 1.75455 13.7337 1.91083 13.5775L6.91083 8.57745C7.23626 8.25201 7.7639 8.25201 8.08934 8.57745Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.256 2.74408C12.5815 3.06951 12.5815 3.59715 12.256 3.92259L8.42615 7.75247C8.27497 7.90799 8.19035 8.11636 8.19035 8.33333C8.19035 8.55031 8.27497 8.75868 8.42615 8.91419L12.7526 13.2406C12.9081 13.3918 13.1165 13.4764 13.3334 13.4764C13.5504 13.4764 13.7588 13.3918 13.9143 13.2406L17.7442 9.41074C18.0696 9.08531 18.5973 9.08531 18.9227 9.41074C19.2481 9.73618 19.2481 10.2638 18.9227 10.5893L15.0835 14.4285C14.6162 14.8865 13.9878 15.1431 13.3334 15.1431C12.6791 15.1431 12.0508 14.8865 11.5834 14.4285L11.5775 14.4226L7.23829 10.0834C6.78023 9.61604 6.52368 8.98772 6.52368 8.33333C6.52368 7.67895 6.78026 7.05066 7.23832 6.58333L7.24416 6.57738L11.0775 2.74408C11.403 2.41864 11.9306 2.41864 12.256 2.74408Z"
        fill="currentColor"
      />
    </svg>
  );
}
